import styled from 'styled-components';
import { Colors } from '../../colors';
export const Container = styled.div `
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 4px;
`;
const appearanceColor = {
    success: Colors.G300,
    warning: Colors.Y300,
};
export const Rectangle = styled.div `
  width: ${({ $rectangleWidth }) => $rectangleWidth};
  height: 20px;
  background-color: ${({ $isActive, $appearance }) => $isActive ? appearanceColor[$appearance] : Colors.GS500};
  border-radius: 4px;
`;
//# sourceMappingURL=styled.js.map